import { LandingPageMetaData } from "@/store/landingPageCreator/types";

export const generateLandingPageMetaTags = (landingPageMetaData: LandingPageMetaData): string => {
    let html = "";

    const pageTitle = landingPageMetaData?.data?.socialPreview?.pageTitle;
    const pageDescription = landingPageMetaData?.data?.socialPreview?.pageDescription;
    const imageUrl = landingPageMetaData?.data?.socialPreview?.imageUrl;

    if (pageTitle || pageDescription || imageUrl) {
        html = `${html}
            <meta name="twitter:card" content="summary_large_image">
        `
    }

    if (pageTitle) {
        html = `${html}
            <title>${pageTitle}</title>
            <meta property="og:title" content="${pageTitle}">
            <meta name="twitter:title" content=${pageTitle}">
        `
    }

    if (pageDescription) {
        html = `${html}
            <meta name="description" content="${pageDescription}">
            <meta property="og:description" content="${pageDescription}">
            <meta name="twitter:description" content="${pageDescription}">
        `
    }

    if (imageUrl) {
        html = `${html}
            <meta property="og:image" content="${imageUrl}">
            <meta name="twitter:image" content="${imageUrl}">
        `
    }
    
    return html
}